
export const locale = {
  lang: 'en',
  data: {
    MENU: {
      DASHBOARD: {
        COLLAPSIBLE: "Dashboard",
        BADGE: "2",
        "description_en":"Description(English)",
        "description_ar":"Description(Arabic)",
        "title_required":"Title Required",
        // "title_required":"Title Required",
       "enter_content_en":" Enter Content (English)   ",
        "enter_content_ar":"Enter Content (Arabic)  ",
        "enter_description_en": "Enter Description in English",
        "enter_description_ar": "Enter Description in Arabic",

        // "content_en":"Content (English)",
        // "content_ar":"Content (Arabic)",
        // "enter_title_en":"Enter title in English",
        // "enter_title_ar":"Enter title in Arabic",

        ANALYTICS: "Analytics",
        ECOMMERCE: "E-Commerce",
        "logout":"Logout",
        "users": "Users",
        "MIRACLE":" MIRACLE ",
        
      "profit_max": "Maximum Profit",
      "from_amount": "From Amount",
      "to_amount": "To Amount",
         "select_all": "Select All",
      "pay_selected": "Pay Selected",
      "installments_selected": "installments selected",
      // "cancel": "Cancel",
      "submit_payment": "Submit Payment",
      // "amount": "Paid Amount",
      // "payment_date": "Payment Date",
      // "transfer_file": "Transfer File",
      "enter_amount": "Enter amount",
      
        "list": "View",
         "employees": "Employees",
         "responsible_employee":"Responsible Employee",
         "no_investors_found":" No Investors Found",
         "no_investors_for_employee":"No Investors For Employee",
         "Upcoming_payments":" Upcoming payments",
          "Active":"Active ",
            "enter_id_number": "Enter ID Number"
,
          "inActive":"inActive",
          "id_number":"Id Number ",
          "nationality":"Nationality",
          "city":"City",
          "contract":"contract number",
          "Rs":"SAR",
          "chat":"Chats",
      "last_chat":"Last Chat",
      "Chat_dash":" Chat Dashboard ",
      "Analysis_chat":"Analysis of all employee conversations with investors",
"Total_investors":"Total Investors",
"Total_employee":"Total Employees",
"Total_messages":"Total Messages",
"Total_conversations":"Total conversations",
"addInvestor":"Add Investor",
      "content": "Content",
            "no_auth_privacy_policy": "No Auth Privacy Policy",
"countries":"Countries",
"active":"Active",
"detailes":"Detailes",
 "receipt_number": "Receipt Number",
      "contract_number": "Contract Number", 
      "payment_date": "Payment Date",
      "amount": "Amount",
      "investor": "Investor",
      "payment_method": "Payment Method",
      "transfer_image": "Transfer Image",
      "view_image": "View Image",
      "paid": "Paid",
      "unpaid": "Unpaid",
      "view_details": "View Details",
      "download_receipt": "Download Receipt",
      "delete": "Delete",

      "edit_countries":"Edit Countries",
      "failed_to_edit_countries":"failed to edit countries",
      "countries_edited_successfully":" countries edited successfully ",
      "select_nationality_first":"Select Nationality First",
      "select_nationality":"select nationality ",
      "cities_added_successfully":"cities added successfully",

      "next_installment_amount": " amount",
      // "payment_date": "payment date ",
      "payment_date_hijri": " payment date hijri",
      "no_data_available": "no data available",
      "selected": "محدد",
              "select_city":" Select City",
"serial_number":"Serial Number",
 "cities_list":"Cities List",
    "investors": "Investors",
    "contracts": "Contracts",
      "alerts_list": "Alerts List",
      "show": "Show",
      "entries": "Entries",
       "add_partners": "Add Partners",
         "add_job_title": "Add Job Title",
      "job_title_name_en": "Job Title Name (EN)",
      "enter_job_title_name_en": "Enter Job Title Name",
      "job_title_name_ar": "Job Title Name ",
      "enter_job_title_name_ar": "Enter Job Title Name",
      "add_job_title_btn": "Add Job Title",
 "notification_content_en": " Notification Content (En)",
       "notification_title_en": " Notification Title  (EN)",
      "partner_logo": "Logo",
      "partners_list": "Partners List",
            "edit_job_title": "Edit Job Title",
      "partner_name": "Name",
       ", All rights Reserved":", All rights Reserved",
 "COPYRIGHT":" COPYRIGHT",

      "investors_list": "Investors List",
        "investor_detailss": "Investor Details",
      "name": "Name",
      "email": "Email",
      "image_preview":"Image Preview",
      "user_name":"User Name ",
      "show_alert": "Show Alert",
      "details": "Details",
      "title": "Title",
      "message": "Message",
      "okay": "Okay",
      "phone": "Phone",
      "employee_id": "Employee ID",
      "edit_investor": "Edit Investor",
      "enter_name": "Enter Name",
      "enter_email": "Enter Email",
      "enter_employee_id": "Enter Employee ID",
      "password": "Password",
      "enter_password": "Enter Password",
      "enter_phone": "Enter Phone",
      "select_type": "Select Type",
      "select_employee":"Select Employee",
      "client": "Client",
      "driver": "Driver",
      "name_ar": "Name (Arabic)",
      "enter_name_ar": "Enter Arabic Name",
      "name_en": "Name (English)",
      "enter_name_en": "Enter English Name",
      "image": "Image",
      "save_changes": "Save Changes",
      "type": "Type",
      "status": "Status",
      "no_image_available": "No Image Available",
      "loading_investor_details": "Loading investor details...",
       "partner_information": "Partner Information",
      "click_to_upload_logo": "Click to upload logo",
      "click_to_upload_imageEmp":"click to upload emplyee image",
      "no_imageEmp_uploaded":"no image uploaded",

      "drag_drop_image": "or drag and drop image here",
      "recommended_size": "Recommended size: 120×70 pixels",
      "remove": "Remove",
      "partner_name_note": "This name will be used in the English interface",
      "enter_full_url": "Enter the full website URL including https://",
      "order": "Order",
      "additional_details": "Additional Details",
      "characters_limit": "250 characters",
      "partner_added_success": "Partner added successfully!",
        "job_title": "Job Title",
          "messages_platform_title": "An integrated platform to track messages - view details and update status smoothly",
      "role": "Investor",
      "replied": "Replied",
      "under_review": "Under Review",
      "not_replied": "Not Replied",
      "message_title": "Message Title",
      "communication_issue": "Communication Issue",
      "message_content": "Message Content",
      "update_status": "Update Status",
      "job_title_list": "Job Title List",
"job_title_list_description": "Easily view and manage all employee job titles in one place.",
      "investor_name": "Name",
      "investor_image": "Image",
            "welcome_to": "Welcome to"
,      "welcome_message": "Welcome to MIRACLE! 👋"
, "title_en": "Title (English)",
 "choose_status": "Choose Status",
 "write_short_description_partner": "Write a short description about the partner...",
      "select_status": "Select Status",
        "send_notifications": "Send Notifications",
      "create_and_send_notifications_easily": "Create and send your notifications easily",
      "create_new_notification": "Create New Notification",
      "notification_title": "Notification Title",
      "notification_content": "Notification Content",
      "recipients": "Recipients",
      "sent": "Sent",
      "all_users": "All Users",
          "choose_user": "Choose User",
        "NOTIFICATION_SUCCESS_TITLE": "Success",
    "NOTIFICATION_SUCCESS_MESSAGE": "Notification sent successfully.",
    "NOTIFICATION_ERROR_TITLE": "Error",
    "NOTIFICATION_ERROR_MESSAGE": "Failed to send notification. Please try again.",
      "featured_users": "Featured Users",
      "new_users": "New Users",
        "notification_type": "Notification Type",
      // "investor": "Investor",
      "specific_user": "Specific User",
      "custom": "Custom",
      "send_notification": "Send Notification",
      "status_updated_successfully": "Status updated successfully",
      "failed_to_update_status": "Failed to update status",
      "enter_title_en": "Enter title in English",
      "add_privacy_policy":"Adding and modifying the privacy policy",
      "mission":"Mission",
            // "countries_list": " countries list",

      "add_mission":"  Adding and modifying Our Mission ",
      "terms_and_conditions":"Terms and Conditions",
"add_terms_and_conditions":"Add Terms and Conditions",
      "content_en": "Content (English)",
      "edit_cities":"Edit Cities",
      "cities_edit_successfully":"Cities Edit Successfully",
              "failed_to_add_cities": "failed to add cities",

 "cities_add_successfully":"Cities Add Successfully",
      "write_content_en": "Write content in English",
      "title_ar": "Title (Arabic)",
      "additional_information": "Additional Information",
      "company": "Company",
      "not_specified": "Not Specified",
      "location": "Location",
       "contract_details": "Contract Details",
      "industry": "Industry",
      "last_activity": "Last Activity",
      "enter_title_ar": "Enter title in Arabic",
      "content_ar": "Content (Arabic)",
      "write_content_ar": "Write content in Arabic",
      "investor_type": "Type",
      "employees_list": "Employees List",
      "employees_list_description": "Here you can track and filter the entire employee record.",
      "employee_email": "Email",
      "employee_job_title": "Job Title",
      "investor_phone": "Phone",
      "investor_email": "Email",
      "signin_message": "Please sign-in to your account and start the adventure",
      "email_required": "Email is required",
      "email_invalid": "Email must be a valid email address",
      "password_required": "Password is required",
      "remember_me": "Remember Me",
      "sign_in": "Sign in",
      "view_current_pdf": "View Current PDF",
"leave_empty_keep_pdf": "Leave empty to keep current PDF",
            "VISION_MISSIONtitle": "Vision & Mission",
      "investor_actions": "Actions",
      "payments_list":"Payments List",
       "failed_to_update_investor":" failed to update investor ",
 "investor_updated_successfully":"investor updated successfully ",
 "employee_updated_successfully":"employee updated successfully",
 "failed_to_update_employee":"  failed to update employee ",
 "confirm_cancel":"confirm cancel",
"payments":"payments",
      "investor_details": "View",
      "investor_edit": "Edit",
      "investor_delete": "Delete",
      "ADMIN_WELCOME": "Welcome to Miracle Administration",
      "END_CONTRACT": "End contract",
      "CONFIRM_END_CONTRACT_TITLE": "End contract?",
      "CONFIRM_END_CONTRACT_TEXT": "The contract and previous payments will be preserved, and no future payments can be recorded.",
      "CONTRACT_ENDED_SUCCESSFULLY": "Contract ended successfully",
      "add_payment":" Add Payment",
      "add_new_payment":"Add New Payment",
      "payment_information": "Payment Information",
      "enter_payment_method": "Enter Payment Method",
      "account_number": "Account Number",
      "enter_account_number": "Enter Account Eumber",
      "click_or_drag_image": " Click Or Drag Image",
      "max_file_size": "Max File Size",
      "file_name": "File Name",
      "size": "Size",
      "remove_image": "Remove Image",
      "all_fields_required": "All Fields Required",
      "are_required": "Are Required",
      "bank_account             ": "Bank Account",
      "partner_url": "URL",
      "partner_description": "Description",
      "partner_add_button": "Add Partners",
       "edit_partners": " Edit Partners ",
      "partner_edit_button": " Update",
      "analytics_overview": "Analytics Overview",
      "number_of_employees": "Number of Employees",
      "number_of_contracts": "Number of Contracts",
      "number_of_projects": "Number of Projects",
      "contracts_list": "Contracts List",
      "search": "Search",
      "id": "ID",
      "faq_title": "Frequently Asked Questions",
      "faq_question_placeholder": "Write the question here...",
      "faq_answer_placeholder": "Write the answer here...",
      "faq_save_button": "Save Changes",
      "link": "Link",
     "write_vision_here": "Write the vision here...",
    "write_goals_here": "Write the goals here...",
    "alerts": "Alerts",
    "terms": "Terms",
    "faq": "FAQ",
    "about_miracle": "About Miracle",
    "partners": "Partners",
    "privacy_policy": "Privacy Policy",
        "add": "Add",
            "analytics": "Analytics",
        "ads": "Ads",
 "countries_name_en_required":"Countries name en required",
 "countries_name_ar_required":"Countries name ar required",
 "enter_countries_name_en":"enter countries name en",
        "add_countries": "Add Countries",
      "countries_name_en": "Countries name ( en )",
      "countries_title_name_en": "Countries title name en ",
      "countries_name_ar": "Countries name ( ar )",
      "enter_countries_name_ar": "   enter countries name ar ",
      "countries_list": " Countries list",
"countries_list_description": "You can easily view all countries from one place.",
        "counselors": "Counselors",
        "stores_offers": "Stores Offers",
         "select_related_news": "Select related news",
  // "related_news": "Related news",
  "related_news_saved_successfully": "Related news saved successfully",
  "error_saving_related_news": "Error saving related news",
        "cancelation_reason": "Cancelation Reason",
        "companies": "Companies",
          "please_select_at_least_one_news": "Please select at least one news"
,    "next": "Next",
      "our_messages_list": "Our Messages List",
      "team_members_list": "TEAM MEMBERS List",
      "edit_reports": "Edit Reports",
       "edit_sectors": "Edit Sectors",
             "view_pdf": "View PDF"
, "transfer_file": "Transfer File",
      "no_file": "No File",
  "edit_news": "Edit News",
  "two_months": "Two Months",
"four_months": "Four Months",
"start_date": "First Payment Date",
"start_date_required": "Start date is required",
   "add_sectors": "Add Sectors",
      "add_sectors_list": "Add Sectors List",
      "our_messages": "Our Messages"
,"add_news": "Add News",
 "add_reports": "Add Reports",
      "add_reports_list": "Add Reports List",
"add_team_members": "Add TEAM MEMBERS",
      "add_team_members_list": "Add TEAM MEMBERS List",
      "add_news_list": "Add News List",
      "additional_images": "Additional Images",
       "edit_team_members": "Edit TEAM MEMBERS",
 "created_at": "Created At",
      "file": "File",
      "view": "View",
  "reports": "Reports",
      "reports_list": "Reports List",
          "prev": "Prev",
        // "payment_date": "Payment Date",
"payment_date_required": "Payment date is required"
,  "icon": "icon",
  "description": "description",
      "slug": "Slug",
      "main_image": "Main Image",
      "published_at": "Published Date",
      "published": "Published",
      "draft": "Draft",
      "related_news": "Related News"
,  "TEAM_MEMBERS": "Team Members"
,
        "consulting": "Consulting",
          "pdf_file": "PDF File"
,"NEWS": "News","NEWS_LIST": "News List",
      "SECTORS_LIST": "Sectors List",
    "SECTORS": "Sectors",
    "vision-ksa": "Vision KSA",
  "MENU.DASHBOARD.Edit_Date": "Edit Date"
,
 "Edit_Date": "Edit Date",
  "DATE_UPDATED_SUCCESS": "Date updated successfully",
  "NO_INSTALLMENT_FOUND": "No installment found",
        "categories": "Categories",
        "services": "Services",
        "tags": "Tags",
        "articles": "Articles",
         "edit_employee": "Edit Employee",
  "employee": "Employee",
      "contract_type": "Contract Type",
      "duration_months": "Duration (Months)",
      "investment_amount": "Investment Amount",
      "investment_rate": "Investment Rate",
      "profit_amount": "Profit Amount",
      "approved": "Approved",
      "pending": "Pending",
      "rejected": "Rejected",
      "loading_employee_details": "Loading employee details...",
      "select_job_title": "Select Job Title",
        "offers": "Offers", 
              "cancel": "Cancel",
               "user_id": "User ID",
                   "select_countries":" select countries",
                            "updated_successfully":"  updated successfully  ",
         "edit_faq":" Edit Faq",
         "add_Vision":"You can now add and edit your vision and mission.",

   "cities":"Cities",
   "Edit_Contract":"Edit Contract",
 "loadin":"Loading cities...",
      "enter_user_id": "Enter user ID",
      "select_contract_type": "Select Contract Type",
      "enter_duration": "Enter duration",
      "enter_investment_amount": "Enter investment amount",
      "enter_investment_rate": "Enter investment rate",
      "enter_profit_amount": "Enter profit amount"
, "CONTRACT_TYPElist": "Contract Type List",
      "CONTRACT_TYPEname_ar": "Name (Arabic)",
        "name_required": "Name is required",
    "name_min_length": "Name must be at least 2 characters",
    "phone_required": "Phone number is required",
    "saudi_phone_only": "Please enter a valid Saudi phone number",
    "id_number_required": "ID number is required",
    "id_number_format": "ID number must be 10 digits",
    "nationality_required": "Nationality is required",
    "nationality_min_length": "Nationality must be at least 2 characters",
    "city_required": "City is required",
    "city_min_length": "City must be at least 2 characters",
    "employee_required": "Please select an employee",
    "image_required": "Image is required",
      "CONTRACT_TYPEname_en": "Name (English)",
        "plantcards": "Plant Cards",
 "add_employee": "Add Employees",
      "add_employee_description": "Welcome to the new employee addition form. Please fill out the following information accurately.",
      "save": "Save",
       "faqs": "Faqs",
       "add_faq_list":"You can now add an unlimited number of questions.",

          "SUCCESS_TITLE": "Welcome back!",
    "SUCCESS_MESSAGE": "Login successful.",
    "FAILED_TITLE": "Login Failed",
    "INVALID_CREDENTIALS": "Invalid email or password.",
    "NETWORK_ERROR": "Network error. Check your connection.",
    "GENERIC_ERROR": "Something went wrong. Please try again later.",
             "rs": "RS"
, "remove_current": "Remove Current",
 "CONFIRM_DELETE_TITLE": "Are you sure?",
  "CONFIRM_DELETE_TEXT": "You won’t be able to revert this!",
  "YES_DELETE": "Yes, delete it!",
  "CANCEL": "Cancel",
        "upload_pdf": "Upload PDF"
,
"pdf": "PDF",

"download_pdf": "Download PDF",
 "Add_Paid_Amount": "Add Paid Amount",
  "Paid_Amount": "Paid Amount",
  "Confirm": "Confirm",
  "Ratio": "Ratio",
  "paid_amount": "Paid Amount",
  file_type_not_supported: "File type is not supported",
file_size_exceeded: "File size exceeds the allowed limit",


transfer_image_required: "Transfer image is required",
"enter_paid_amount": "Enter paid amount",
"paid_amount_required": "Paid amount is required",
  "Cancel": "Cancel",
  "PAID_SUCCESS": "Paid amount added successfully",
  "vision_ar": "Vision (AR)",
  payment_method_required: "Payment method is required",
payment_method_min_length: "Payment method must be at least 3 characters",
payment_method_max_length: "Payment method must not exceed 50 characters",

account_number_required: "Account number is required",
account_number_min_length: "Account number must be at least 5 characters",
account_number_max_length: "Account number must not exceed 30 characters",
account_number_pattern: "Account number format is invalid",
  "partner_description_ar": "Partner Description (AR)",
      "write_short_description_partner_ar": "Write a short description about the partner in Arabic...",
      "vision_en": "Vision (EN)",
      "partner_description_en": "Partner Description (EN)",
      "write_short_description_partner_en": "Write a short description about the partner...",
      "goals_ar": "Goals (AR)",
      "goals_en": "Goals (EN)",
       "Transfer_Image": "Transfer Image",
     
    "job_title_required": "Job title is required.",
    "password_min_length": "Password must be at least 6 characters long.",
      "investment": "Investment"
,"total": "Total",
 "phone_invalid": "Please enter a valid phone number",
"INVESTOR_ADD_SUCCESS_TITLE": "Investor Added",
 "partner_added_successfully": "Partner added successfully",
  "something_went_wrong": "Something went wrong",
"INVESTOR_ADD_SUCCESS_MESSAGE": "The investor has been added successfully.",
"FIELD_EMPLOYEE_ERROR": "Employee field is required.",
"FIELD_CITY_ERROR": "City field is required.",
"FIELD_NATIONALITY_ERROR": "Nationality field is required.",
"FIELD_IDENTITY_NUMBER_ERROR": "Identity number is required."
,
"faq_updated_successfully": "FAQ updated successfully",
    "failed_to_update_faq": "Failed to update FAQ",
"EMPLOYEE_ADD_SUCCESS_TITLE": "Success",

    "EMPLOYEE_ADD_SUCCESS_MESSAGE": "Employee added successfully!",
    "ERROR_TITLE": "Error",
     "job_title_id_missing": "Job title ID is missing",
      "select_user": "Select User",
     "contract_type_added_successfully": "Contract type added successfully",
    "fill_required_fields": "Please fill all required fields",
     "user_required": "User is required",
    "contract_type_required": "Contract type is required",
      "select_user_required": "Please select a user",
    
      "name_ar_required": "Please enter the Arabic name",
      "name_en_required": "Please enter the English name",
      "select_contract_type_required": "Please select a contract type",
      "select_duration_required": "Please select a duration",
      "enter_investment_amount_required": "Please enter the investment amount",
      "enter_investment_rate_required": "Please enter the investment rate",
    "duration_required": "Duration is required",
    "investment_amount_required": "Investment amount is required",
    "investment_rate_required": "Investment rate is required",
     "contract_updated_successfully": "Contract updated successfully",
   
      "record_updated_successfully": "Record updated successfully",
    "failed_to_update_record": "Failed to update record",
  
    "missing_id": "Record ID is missing",
    "titlee": "Delete Account",
    "messagee": "Once your account is deleted, it cannot be restored.",
    "button": "Delete Account",
     "flag_true": "Your account is currently deleted.",
    "flag_false": "Your account is active.",
    "disabled": "Delete account feature is currently disabled.",
    "confirm_title": "Are you sure?",
    "confirm_message": "This action will permanently delete your account.",
    "confirm": "Yes, Delete",
    "success": "Your account has been deleted successfully.",
    "error": "An error occurred. Please try again.",
    "failed_to_update_contract": "Failed to update contract",
   
      "job_title_name_en_required": "English job title is required",
      "job_title_name_ar_required": " job title is required",
    "contract_id_missing": "Contract ID is missing",

     "contract_added_successfully": "Contract added successfully",
    "job_title_updated_successfully": "Job title updated successfully",
    "contact_us": "Contact Us",
      "contact_us_list": "Contact Us List",
    "failed_to_update_job_title": "Failed to update job title",
     "DELETED_SUCCESSFULLY": "Deleted successfully",
  "SOMETHING_WENT_WRONG": "Something went wrong",
      "write_title_here_ar": "اكتب العنوان العربي هنا...",

      "write_content_here_ar": "اكتب المحتوى العربي هنا...",

      "write_title_here_en": "اكتب العنوان الإنجليزي هنا...",

      "write_content_here_en": "اكتب المحتوى الإنجليزي هنا..."
    ,
  //    "employee_updated_successfully": "Employee updated successfully",
  // "failed_to_update_employee": "Failed to update employee",
    "FIELD_EMAIL_ERROR": "Invalid email address.",
     "faq_added_successfully": "FAQ added successfully",
      "job_title_added_successfully": "Job title added successfully",
    "failed_to_add_job_title": "Failed to add job title",
     "partner_id_missing": "Partner ID is missing",
      "question_required": "Question field is required",
            "all_countries": "All Countries"
,
      "country": "Country"
,
    "answer_required": "Answer field is required",
    "fill_all_required_fields": "Please fill all required fields",
    "partner_updated_successfully": "Partner updated successfully",
    "FIELD_JOB_TITLE_ERROR": "Please select a job title.",
    "FIELD_NAME_ERROR": "Name field is required.",
    "FIELD_PHONE_ERROR": "Invalid phone number.",
    "question_ar": "Question (Arabic)",
      "question_en": "Question (English)",
      "answer_ar": "Answer (Arabic)",
      "answer_en": "Answer (English)",
      "current_logo": "Current Logo",
      "add_cities":"Add Cities",
 "cities_name_en_required":"cities name en required",
 "cities_name_ar_required":" cities name ar required",
 "enter_cities_name_en":"enter cities name en",
      "cities_name_en": "cities name en",
      "cities_title_name_en": "cities title name en",
      "cities_name_ar": "cities name ar",
      "enter_cities_name_ar": "enter cities name ar",
      "remove_new": "Remove New",
          "notification_title_ar": "Notification Title (Ar)",
    "notification_content_ar": "Notification Content (Ar)",
      "loading_partner_data": "Loading partner data...",
      "new_logo_preview": "New logo preview",
      "no_logo_uploaded": "No logo uploaded",
      "english_interface_note": "This name will be used in the English interface",
      "characters": "characters",
       "monthly": "Monthly",
        "contract_details_form": "Contract Details Form",
      "payment_data": "Payment Data",
      // "amount": "Amount",
      // "add_new_payment": "إضافة دفعة جديدة",

      "quarterly": "Quarterly",
      "semi_annually": "Semi-Annually",
      "annually": "Annually",
      "faqs_list": "Faqs List",
      "question": "Question",
       "body_ar": "Notification Body (AR)",
      "body_en": "Notification Body (EN)",
      "answer": "Answer",
        "Settings": "Settings",
        "ShowDetails": "Show Details",
        "TermsAndConditions": "Terms & Conditions",
        "About": "About",
        "Notifications": "Notifications",
        "Currencies": "Currencies",
        "Countries": "Countries",
        "Cities": "Cities",
        "plans": "plans",
        "date": "Date",
        "search_user": "Search user",
      "light": "light",
      "root": "root",
      "seed": "seed",
      "soil": "soil",
      "stem": "stem",
      "counselorspayment": "counselorspayment",
      "OpenScreens": "Open Screens",
      "GanatakCommunity": "Ganatak Community",
      "Paperform": "Paperform",
      "Sizes": "Sizes",
      "Sliders": "Sliders",
      "investment_rate_min":"Investment Rate Min",
      "investment_rate_max":"Investment Rate Max",
          "add_about_miracle":"You can now add and edit the content of the About Us page.",


      "error_adding_payment":"  error adding payment",
      "payment_added_successfully":"payment added successfully",
      // "add_new_payment": "Add New Payment",
      // "payment_information": "Payment Information",
      // "payment_method": "Payment Method",
      // "enter_payment_method": "Enter payment method",
      // "account_number": "Account Number",
      // "enter_account_number": "Enter account number",
      // "transfer_image": "Transfer Image",
      // "click_or_drag_image": "Click or drag image here",
      // "max_file_size": "Maximum file size: 5MB",
      // "file_name": "File Name",
      // "size": "Size",
      // "remove_image": "Remove Image",
      // "add_payment": "Add Payment",
      "sending": "Sending...",
      // "payment_added_successfully": "Payment added successfully",
      // "error_adding_payment": "Error adding payment",
      // "all_fields_required": "All fields",
      // "are_required": "are required"
      },
      VALIDATION: {
    "name_required": "Name is required",
    "name_min_length": "Name must be at least 2 characters",
    "email_required": "Email is required",
    "email_invalid": "Please enter a valid email address",
    "phone_required": "Phone number is required",
    "saudi_phone_only": "Please enter a valid Saudi phone number",
    "id_number_required": "ID number is required",
    "id_number_format": "ID number must be 10 digits",
    "nationality_required": "Nationality is required",
    "nationality_min_length": "Nationality must be at least 2 characters",
    "city_required": "City is required",
    "city_min_length": "City must be at least 2 characters",
    "employee_required": "Please select an employee",
    "image_required": "Image is required",
    "payment_method_required": "Payment method is required",
    "payment_method_min_length": "Payment method must be at least 2 characters",
    "payment_method_max_length": "Payment method must not exceed 100 characters",
    "account_number_required": "Account number is required",
    "account_number_min_length": "Account number must be at least 5 digits",
    "account_number_max_length": "Account number must not exceed 50 digits",
    "account_number_pattern": "Account number must contain only numbers",
    "transfer_image_required": "Transfer image is required",
    "file_type_not_supported": "File type not supported. Please upload an image in JPEG, PNG, JPG, or GIF format",
    "file_size_exceeded": "File size is too large. Maximum size is 5MB",
    //   "payment_method_required": "Payment method is required",
    // "payment_method_min_length": "Payment method must be at least 2 characters",
    // "payment_method_max_length": "Payment method must not exceed 100 characters",
    // "account_number_required": "Account number is required",
    // "account_number_min_length": "Account number must be at least 5 digits",
    // "account_number_max_length": "Account number must not exceed 50 digits",
    // "account_number_pattern": "Account number must contain numbers only",
    // "transfer_image_required": "Transfer image is required",
    // "file_type_not_supported": "File type not supported. Please use an image (JPEG, PNG, JPG, GIF, WebP)",
    // "file_size_exceeded": "File size exceeds allowed limit (5MB)"
  },
  "COMMON": {
    "required": "Required",
    "optional": "Optional",
    "success": "Success",
    "error": "Error",
    "loading": "Loading...",
    "submit": "Submit",
    "cancel": "Cancel",
    "back": "Back"
  },
  "CHAT": {
    "TITLE": "Chat Details",
    "LOADING": "Loading conversation...",
    "ERROR": "Error loading conversation",
    "ONLINE": "Online now",
    "FIRST_MESSAGE": "First message",
    "MESSAGES": "message",
    "MESSAGES_PLURAL": "{{count}} messages",
    "SECURE_CHAT": "Secure encrypted chat",
    "SENT": "Sent",
    "RECEIVED": "Received",
    "IMAGE": "Image",
    "TYPE_MESSAGE": "Type your message here...",
    "SEND": "Send"
  },
  "DATE": {
    "TODAY": "Today",
    "YESTERDAY": "Yesterday"
  },
      USERS_SECTION: "Customers",
      USERS: {
        LIST: "Users List",
        ADD: "Add User"
      },
      PRODUCTS: {
        Title: "Products",
        LIST: "Products List",
        AT_HOME: "Products at Home"
      },
      COUNSELORS: {
        Title: "Consultants",
        LIST: "Consultants List",
        ADD: "Add Consultant"
      },
      STORES: {
        Title: "Stores",
        LIST: "Stores List",
        ADD: "Add Store"
      },
      STORES_OFFERS: {
        Title: "Store Offers",
        LIST: "Offers List"
      },
      VOUCHER: {
        Title: "Promotions",
        TYPE: "Promotion Types",
        LIST: "Promotions List"
      },
      cancelation_reasons: {
        Title: "Cancellation Reason",
        LIST: "Cancellation Reasons List",
        ADD: "Add Reason"
      },
      COMPANIES: {
        Title: "Companies",
        LIST: "Companies List",
        ARCHIVED: "Archived Companies",
        ADD: "Add Company"
      },
      consulting: {
        Title: "Consulting",
        LIST: "Consulting List",
      },
      SERVICES: {
        Title: "Services",
        LIST: "Services List",
        ADD: "Add Service"
      },
      SECTION: {
        Title: "Sections",
        LIST: "Sections List",
        TYPES: "Voucher Types",
        ADD: "Add Section"
      },
      ARTICLES: {
        Title: "Articles",
        LIST: "Articles List",
        Plant_groups: "Plant Groups",
        ADD: "Add",
        various: "Various Agricultural Articles",
      },
      TAGS: {
        Title: "Tags",
        LIST: "Tags List",
        ADD: "Add Tag"
      },
      offers: {
        Title: "Offers",
        LIST: "Offers List",
        ADD: "Add Offers"
      },
      reasone_canceled: {
        Title: "Cancellation Reason",
        LIST: "List",
        ADD: "Add"
      },
      PLANTCARDS: {
        TITLE: "Plant Cards",
        LIST: "Plant Cards List",
        ADD: "Add Plant Card",
        LEAVERSCOLOR: {
          TITLE: "Leaf Colors",
          LIST: "Leaf Colors List",
          ADD: "Add Leaf Color"
        },
        LEAVERSFORM: {
          TITLE: "Leaf Shapes",
          LIST: "Leaf Shapes List",
          ADD: "Add Leaf Shape"
        },
        FLOWERFORM: {
          TITLE: "Flower Shapes",
          LIST: "Flower Shapes List",
          ADD: "Add Flower Shape"
        },
        FLOWERCOLOR: {
          TITLE: "Flower Colors",
          LIST: "Flower Colors List",
          ADD: "Add Flower Color"
        },
        ENVIRONMENTLIGHT: {
          TITLE: "Environmental Light",
          LIST: "Environmental Light List",
          ADD: "Add Environmental Light"
        },
        ENVIRONMENTTEMP: {
          TITLE: "Environmental Temperature",
          LIST: "Environmental Temperature List",
          ADD: "Add Environmental Temperature"
        },
        ENVIRONMENHUMIDITY: {
          TITLE: "Environmental Humidity",
          LIST: "Environmental Humidity List",
          ADD: "Add Environmental Humidity"
        },
        REPRODUCTIONS: {
          TITLE: "Reproduction",
          LIST: "Reproduction Methods List",
          ADD: "Add Reproduction Method"
        },
        PLANTCARDSOIL: {
          TITLE: "Soil Types",
          LIST: "Soil Types List",
          ADD: "Add Soil Type"
        },
        
      }
        
    }
  }


}
